import { Component } from '@angular/core';

@Component({
  selector: 'app-editor-component-long-text',
  templateUrl: 'long-text.component.html'
})
export class EditorLongTextComponent {

}
